import React from 'react';
import { FaArrowUp, FaArrowDown, FaArrowLeft, FaArrowRight, FaInfoCircle, FaExternalLinkAlt } from 'react-icons/fa';
import './ThumbNavigator.css';

const ThumbNavigator = ({
  onPrev,
  onNext,
  onPrevSubject,
  onNextSubject,
  infoUrl,
  vizUrl,
  onInfoClick,
  onNewTabClick
}) => {
  return (
    <div className="navigator-cluster">
      <div className="info-actions">
        {infoUrl && (
          <button onClick={onInfoClick} className="nav-button info" title="Info">
            <FaInfoCircle size={22} />
          </button>
        )}
      </div>
      <div className="thumb-navigator">
        <button onClick={onNextSubject} className="nav-button up" title="Next Subject">
          <FaArrowUp />
        </button>
        <div className="horizontal-buttons">
          <button onClick={onPrev} className="nav-button left" title="Previous Visualization">
            <FaArrowLeft />
          </button>
          <button onClick={onNext} className="nav-button right" title="Next Visualization">
            <FaArrowRight />
          </button>
        </div>
        <button onClick={onPrevSubject} className="nav-button down" title="Previous Subject">
          <FaArrowDown />
        </button>
      </div>
    </div>
  );
};

export default ThumbNavigator;